export default __webpack_public_path__ + "img/logo2_footer.4cdbfc4c.png";